<template>
  <div class="">
    <HomeCarousel class="carousel-web"></HomeCarousel>
    <HomeCarouselMobile class="carousel-mobile"></HomeCarouselMobile>
    <HomeProduct></HomeProduct>
    <HomeAbout></HomeAbout>
    <HomeSourceCenter></HomeSourceCenter>
    <!-- <HomeNews v-if="$i18n.locale === 'zh'"></HomeNews> -->
    <HomeNews></HomeNews>
    <HomeCooperate></HomeCooperate>
  </div>
</template>

<script>
  import HomeCarousel from './HomeCarousel'
  import HomeCarouselMobile from './HomeCarouselMobile'
  import HomeAbout from './HomeAbout'
  import HomeSourceCenter from './HomeSourceCenter'
  import HomeProduct from './HomeProduct'
  import HomeNews from './HomeNews'
  import HomeCooperate from './HomeCooperate'

export default {
  name: 'HelloWorld',
  props: {

  },
  components: {
    HomeCarousel,
    HomeCarouselMobile,
    HomeAbout,
    HomeSourceCenter,
    HomeProduct,
    HomeNews,
    HomeCooperate
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .carousel-web{

  }
  .carousel-mobile{
    display: none;
  }


  @media (max-width: 768px) {

    .carousel-web{
      display: none;
    }
    .carousel-mobile{
      display: block;
    }
  }



</style>
